import React, { useEffect } from "react";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

import ProfileService from "../../services/ProfileService";

const SsoLogin = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const accessToken = params.get("access_token");
    const redirectUrl = params.get("redirect")
      ? decodeURIComponent(params.get("redirect"))
      : "/user/dashboard";

    if (!accessToken) {
      Swal.fire("Oops!", "Missing access token", "error");
      return;
    }

    fetchProfile(accessToken, redirectUrl);
  }, [location.search]);

  const fetchProfile = async (accessToken, redirectUrl) => {
    try {
      localStorage.setItem("access_token", accessToken);

      const result = await ProfileService.fetch(accessToken);

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status == "SUCCESS") {
        const {
          name,
          user_id,
          user_type,
          mobile,
          premium_subscription_status,
        } = responseData.data;

        // Save session
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("user_id", user_id);
        localStorage.setItem("mobile", mobile);
        localStorage.setItem("user_type", user_type);
        localStorage.setItem("name", name);
        localStorage.setItem(
          "premium_subscription_status",
          premium_subscription_status,
        );

        // Redirect
        window.location.replace(redirectUrl);
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      const errMsg =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong";

      Swal.fire("Oops!", errMsg, "error");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <h5>Please wait...</h5>
      <p>Redirecting to your account</p>
    </div>
  );
};

export default SsoLogin;
